import { jsx } from "react/jsx-runtime";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import { validateTidalLicense } from "../../base/index.js";
function KeyboardDoubleArrowRight(props) {
  return /* @__PURE__ */ jsx(
    KeyboardDoubleArrowRightIcon,
    {
      "data-testid": "KeyboardDoubleArrowRight",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "KeyboardDoubleArrowRight",
      "data-tidal-icon-meta": "arrows"
    }
  );
}
KeyboardDoubleArrowRight.tidalIconMeta = {
  categories: "arrows",
  name: "KeyboardDoubleArrowRight"
};
validateTidalLicense();
export {
  KeyboardDoubleArrowRight
};
//# sourceMappingURL=KeyboardDoubleArrowRight.js.map
